// extracted by extract-css-chunks-webpack-plugin
module.exports = {"headerContainer":"headerContainer-24IGu","underlined":"underlined-3UMwn","light":"light-150Sw","ghosted":"ghosted-HdGeg","secondary":"secondary-1JMtK"};